import { useEffect, useState } from 'react';

import { isMac } from '@/utils/capabilities';

import type { DevicePermissionStatus } from '@electron/shared/permission.types';

interface ContactsState {
  contactsGranted: boolean;
  contactsStatus: DevicePermissionStatus | null;
}

const DEFAULT_STATE: ContactsState = {
  contactsGranted: false,
  contactsStatus: null,
};

export function useContactsState(enabled = true): ContactsState {
  const [state, setState] = useState<ContactsState>(DEFAULT_STATE);

  useEffect(() => {
    if (!enabled || !isMac()) {
      return;
    }

    window.mainProcessApi.getContactsState().then(setState);
    const cleanup = window.mainProcessApi.onContactsStateChanged(setState);
    return cleanup;
  }, [enabled]);

  return state;
}
